import PropTypes from 'prop-types'
import { COACH_PROFILE_FILTER_ICON_PROPS } from '@lib/pga-coach/coach-profile-icons'
import { OFFERING_FORMAT_ICON_COMPONENTS } from '@lib/pga-coach/offering-format-icons'

/**
 * Format filter pill icons for the flag-gated coach profile Services shop.
 * Same map as `/golf-lessons` so the two surfaces cannot drift apart.
 */
export const COACH_PROFILE_OFFERING_FORMAT_ICON_COMPONENTS = OFFERING_FORMAT_ICON_COMPONENTS

export function CoachProfileFilterFormatIcon({ iconKey, ...props }) {
  const Icon = COACH_PROFILE_OFFERING_FORMAT_ICON_COMPONENTS[iconKey]
  if (!Icon) return null
  return <Icon {...COACH_PROFILE_FILTER_ICON_PROPS} {...props} />
}

CoachProfileFilterFormatIcon.propTypes = {
  iconKey: PropTypes.string,
}
